// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { errorFetchingListData } from '@epicuro-next/constants/features/localization';
import { ProductListResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { IDynamicSimpleText } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import {
  createInstanceWithChildren,
  getIdProvider,
  getProvider,
} from '../../../utils/dynamic-items-utils';
import {
  getScrollableContainer,
  ScrollableContainerDataProviders,
} from '../../components/scrollable-container';
import {
  getDataLoadingPropertiesForProductSearchFromProductReferences,
  getListDataProperties,
} from '../../lists';
import { errorMessage } from '../../loading-state-wrapper-helpers';

const references = {
  panelFromListListDataContainer: {
    id: 'panel-from-list-list-data-container',
    properties: {
      listData: 'listData',
    },
  },
};

export const panelFromListRoot = createInstanceWithChildren({
  id: 'panel-from-list-root',
  contentTypeId: 'dynamic-collections-renderer',
  data: {
    header: {
      ...getIdProvider(
        references.panelFromListListDataContainer.id,
        references.panelFromListListDataContainer.properties.listData,
      ),
      transform: function (listData: ProductListResponseDto): string {
        return window.neoclesDynamicFramework.recommendationsPanels.methods.decode(
          listData.name,
        );
      }.toString(),
    },
    listId: 'e2623b68-5a0e-4bb5-aa1a-9834a680ce72',
    panelName: 'panel-from-list',
    panelStyle: 'panel-style-not-configured-yet',
    showHeader: true,
  },
  styles: {
    classes: ['d-block', 'text-center'],
  },
  children: [],
});

const headerText: IDynamicSimpleText = {
  id: 'header-text',
  contentTypeId: 'dynamic-elements-simple-text',
  if: ['EQ', [getProvider(panelFromListRoot, 'showHeader'), true]],
  styles: {
    style: { 'font-size': '2rem' },
    variables: {
      '--text-dynamic-color': 'var(--dark-mode-gray-600, #414141)',
    },
  },
  inputs: {
    text: getProvider(panelFromListRoot, 'header'),
  },
};
panelFromListRoot.children.push(headerText);

const listDataContainer = createInstanceWithChildren({
  id: references.panelFromListListDataContainer.id,
  contentTypeId: 'dynamic-collections-renderer',
  data: {
    ...getListDataProperties({
      listId: getProvider(panelFromListRoot, 'listId'),
    }),
  },
  children: [errorMessage(errorFetchingListData)],
});
panelFromListRoot.children.push(listDataContainer);

const productDataContainer = createInstanceWithChildren({
  id: 'panel-from-list-products-data-container',
  contentTypeId: 'dynamic-collections-renderer',
  data: {
    ...getDataLoadingPropertiesForProductSearchFromProductReferences({
      productReferences: getProvider(listDataContainer, 'productReferences'),
      listId: getProvider(panelFromListRoot, 'listId'),
    }),
  },
  children: [],
});

listDataContainer.children.push(productDataContainer);

// const panelNameProvider = getProvider(panelFromListRoot, 'panelName');
// const panelStyleProvider = getProvider(panelFromListRoot, 'panelStyle');

const dataProviders: ScrollableContainerDataProviders = {
  hasError: getProvider(productDataContainer, 'hasError'),
  isLoading: getProvider(productDataContainer, 'isLoading'),
};

// const eventHandlers = {
//   onClick: [
//     openConfigStripEventHandler('self'),
//     configStripSetProductSource({
//       listIdProvider: getProvider(panelFromListRoot, 'listId'),
//       panelNameProvider,
//       panelTrackingIdProvider: panelStyleProvider,
//     }),
//     recommendationItemClickedEventHandler(
//       getProvider(panelFromListRoot, 'panelName'),
//       getProvider(panelFromListRoot, 'panelStyle'),
//       getProvider(productDataContainer, 'productData'),
//     ),
//   ],
//   onVisibleOnce: [
//     recommendationItemShownEventHandler(
//       getProvider(panelFromListRoot, 'panelName'),
//       getProvider(panelFromListRoot, 'panelStyle'),
//       getProvider(productDataContainer, 'productData'),
//     ),
//   ],
// };

// const view = getProductAsLoadableImageView(eventHandlers);

const horizontalScrollableContainer = getScrollableContainer(dataProviders);

productDataContainer.children.push(
  horizontalScrollableContainer.scrollableContainer,
);
